module.exports = __webpack_public_path__ + "static/dp-98bc12868d167e18d19d5baf9a2b2ea2.jpg";